import { render } from "./mzsm.vue?vue&type=template&id=61f671d4&scoped=true"
import script from "./mzsm.vue?vue&type=script&lang=js"
export * from "./mzsm.vue?vue&type=script&lang=js"

import "./mzsm.vue?vue&type=style&index=0&id=61f671d4&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f671d4"]])

export default __exports__